import { closedSalesApiConfig } from '@/config/api/closedSales';
import { useClientApi } from '@/plugins/api/lk';
import { fullLogDecorate } from '@/shared/lib';

import type { CancelRequestPayload } from '../model/types';

export const submitRequest = fullLogDecorate(async () => {
  const url = closedSalesApiConfig.submitRequest;
  const { data } = await useClientApi().post(url);

  return data;
}, '🚀 ~ file: closedSales/api ~ sendRequest ~ error', true);

export const cancelRequest = fullLogDecorate(async () => {
  const url = closedSalesApiConfig.cancelRequest;
  const { data } = await useClientApi().post(url);

  return data;
}, '🚀 ~ file: closedSales/api ~ cancelRequest ~ error', true);

export const cancelRequestV2 = fullLogDecorate(async (payload: CancelRequestPayload) => {
  const url = closedSalesApiConfig.cancelRequestV2;
  const { data } = await useClientApi().post(url, payload);

  return data;
}, '🚀 ~ file: closedSales/api ~ cancelRequestV2 ~ error', true);

export const checkStatusRequest = fullLogDecorate(async () => {
  const url = closedSalesApiConfig.checkRequest;
  const { data } = await useClientApi().get(url);

  return data.status;
}, '🚀 ~ file: closedSales/api ~ checkStatus ~ error', true);
